var _excluded = ["disabled", "label", "labelOnBorder", "value", "options", "onChange", "className", "placeholder", "dataHelpTip", "canLoadMore", "onLoadMore", "isRequesting", "showPlaceholderText"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Grid, FormControl, TextField, InputLabel, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/styles';
import { controlLabelStyles, controlFormStyles, pxToRem } from "../../common";
import LoadMore from "../LoadMore";
var PREFIX = 'BrandSelect';
var classes = {
  transferOwnerShipBtn: "".concat(PREFIX, "-transferOwnerShipBtn"),
  controlLabel: "".concat(PREFIX, "-controlLabel"),
  formControl: "".concat(PREFIX, "-formControl"),
  disabled: "".concat(PREFIX, "-disabled"),
  fullWidthInput: "".concat(PREFIX, "-fullWidthInput"),
  gridItem: "".concat(PREFIX, "-gridItem"),
  input: "".concat(PREFIX, "-input"),
  popOver: "".concat(PREFIX, "-popOver")
};
var StyledGrid = styled(Grid)(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "& .".concat(classes.transferOwnerShipBtn), {
    height: '50px',
    gridColumnStart: 2,
    justifySelf: 'center',
    alignSelf: 'flex-end',
    textTransform: 'none'
  }), "& .".concat(classes.controlLabel), controlLabelStyles(theme)), "& .".concat(classes.formControl), controlFormStyles(theme)), "& .".concat(classes.disabled), {
    color: theme.palette.font.primary,
    opacity: 0.6
  }), "& .".concat(classes.fullWidthInput), {
    width: '100%'
  }), "& .".concat(classes.gridItem), {
    width: '100%'
  }), "& .".concat(classes.input), {
    '& label': {
      color: "".concat(theme.palette.font.primary, " !important"),
      backgroundColor: 'transparent'
    }
  }), "& .".concat(classes.popOver), {
    '&.MuiPaper-root > ul': {
      background: theme.palette.popover.primary
    },
    '&.MuiPaper-root > ul > li': {
      color: theme.palette.font.primary,
      whiteSpace: 'pre-wrap'
    },
    '&.MuiPaper-root > ul > .MuiListItem-button:hover': {
      background: theme.palette.popover.hover.primary
    }
  }), '& .BrandSelect-disabled', {
    WebkitTextFillColor: "".concat(theme.palette.font.primary, " !important"),
    opacity: 0.5
  });
});
var StyledMenuItem = styled(MenuItem)(function (_ref3) {
  var theme = _ref3.theme;
  return _defineProperty({
    fontSize: pxToRem(16)
  }, theme.breakpoints.down('md'), {
    fontSize: pxToRem(12)
  });
});
var BrandSelect = function BrandSelect(_ref5) {
  var disabled = _ref5.disabled,
    label = _ref5.label,
    _ref5$labelOnBorder = _ref5.labelOnBorder,
    labelOnBorder = _ref5$labelOnBorder === void 0 ? true : _ref5$labelOnBorder,
    value = _ref5.value,
    options = _ref5.options,
    onChange = _ref5.onChange,
    className = _ref5.className,
    placeholder = _ref5.placeholder,
    dataHelpTip = _ref5.dataHelpTip,
    canLoadMore = _ref5.canLoadMore,
    onLoadMore = _ref5.onLoadMore,
    isRequesting = _ref5.isRequesting,
    _ref5$showPlaceholder = _ref5.showPlaceholderText,
    showPlaceholderText = _ref5$showPlaceholder === void 0 ? false : _ref5$showPlaceholder,
    props = _objectWithoutProperties(_ref5, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(StyledGrid, {
    item: true,
    className: className,
    "data-helptip": dataHelpTip
  }, label && !labelOnBorder && /*#__PURE__*/React.createElement(InputLabel, {
    className: classes.controlLabel,
    color: "primary"
  }, label), /*#__PURE__*/React.createElement(FormControl, {
    className: classes.fullWidthInput
  }, /*#__PURE__*/React.createElement(TextField, _extends({
    select: true,
    color: "primary",
    variant: "outlined",
    size: "small",
    disabled: disabled,
    label: labelOnBorder ? value === null || value === undefined || value === '' ? placeholder : label : null,
    className: classes.input,
    InputProps: {
      className: classes.formControl,
      classes: {
        disabled: classes.disabled
      }
    },
    InputLabelProps: {
      className: classes.formControl
    },
    SelectProps: {
      MenuProps: {
        PaperProps: {
          sx: {
            backgroundColor: theme.palette.table.filter.secondary,
            color: theme.palette.font.secondary,
            maxHeight: '270px'
          }
        },
        PopoverClasses: {
          paper: classes.popOver
        }
      }
    },
    value: value
  }, props), showPlaceholderText && /*#__PURE__*/React.createElement(StyledMenuItem, {
    disabled: true,
    value: "nil",
    sx: {
      display: 'none'
    }
  }, placeholder), options.length ? [options.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(StyledMenuItem, {
      key: idx,
      value: item.value,
      onClick: function onClick() {
        return onChange(item.value, item.label);
      }
    }, item.label);
  }), canLoadMore && /*#__PURE__*/React.createElement(LoadMore, {
    key: "load-more",
    isRequesting: isRequesting,
    onLoadMore: onLoadMore
  })] : /*#__PURE__*/React.createElement(StyledMenuItem, {
    key: "no-options"
  }, t('there_are_no_options_to_select')))));
};
BrandSelect.propTypes = {
  isRequesting: PropTypes.bool,
  onLoadMore: PropTypes.func,
  canLoadMore: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.any,
  labelOnBorder: PropTypes.bool,
  value: PropTypes.any,
  options: PropTypes.array,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  dataHelpTip: PropTypes.string,
  showPlaceholderText: PropTypes.bool
};
export default BrandSelect;